var _style, _rect, _circle, _path, _line, _line2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemporary1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    className: "st0",
    width: 26,
    height: 16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 16,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,22c0-2.2,1.8-4,4-4s4,1.8,4,4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 16,
    x2: 25,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    y1: 20,
    x2: 25,
    y2: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,10h-8V9c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4V10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemporary1);
export default __webpack_public_path__ + "static/media/temporary1.8735fadd93bfbf13f1fbb97ab1b1c16a.svg";
export { ForwardRef as ReactComponent };